import React from 'react';
import { WidgetNames } from "../../constants/WidgetNames";
import * as Widgets from "../Widgets";

const widgetComponents = {
    [WidgetNames.SENTIMENT_OVER_TIME_LINE]: Widgets.SentimentOverTimeLineGraph,
    [WidgetNames.LARGEST_SENTIMENT_MOVEMENT]: Widgets.LargestSentimentMovement,
    [WidgetNames.LARGEST_NET_SENTIMENT_MOVEMENT]: Widgets.NetSentimentChangeWidget,
    [WidgetNames.OVERALL_SENTIMENT]: Widgets.SentimentWidget,
    [WidgetNames.VOLUME]: Widgets.VolumeDaylightWidget,
    [WidgetNames.LARGEST_CONCEPT_MOVEMENT]: Widgets.LargestConceptMovement,
    [WidgetNames.VOLUME_OVER_TIME]: Widgets.VolumeOverTime,
    [WidgetNames.SHARE_OF_VOICE_OVER_TIME]: Widgets.ShareOfVoiceOverTime,
    [WidgetNames.SHARE_OF_VOICE_OVER_TIME_BUBBLE]: Widgets.ShareOfVoiceOverTimeBubble,
    [WidgetNames.NUMBER_METADATA_BREAKDOWN]: Widgets.NumberMetadataBreakdown,
    [WidgetNames.QUALITATIVE_METADATA_BREAKDOWN]: Widgets.QualitativeMetadataBreakdown,
    [WidgetNames.DRIVERS]: Widgets.ScoreDriversWidget,
    [WidgetNames.SENTIMENT_SHARE_BAR_CHART]: Widgets.SentimentShareBarChart,
    [WidgetNames.SENTIMENT_SHARE]: Widgets.SentimentShare,
    [WidgetNames.DRIVERS_OVER_TIME]: Widgets.DriversOverTime,
    [WidgetNames.DRIVERS_DIFFERENCE_FROM_AVERAGE]: Widgets.DriversDifferenceFromAverage,
    [WidgetNames.IMPACT_SCORE]: Widgets.ImpactScore,
    [WidgetNames.SENTIMENT]: Widgets.SentimentHeatMap,
    [WidgetNames.NET_SENTIMENT_FOR_CONCEPT_OVER_TIME]: Widgets.SentimentOverTimeTrellisGraphs,
    [WidgetNames.OUTLIER_PERCENTAGE]: Widgets.OutlierWidgetPercentage,
    [WidgetNames.DOCUMENTS]: Widgets.DocumentsViewer,
    [WidgetNames.AVERAGE_SCORE]: Widgets.AverageScoreViewer,
    [WidgetNames.AVERAGE_SCORE_OVERTIME]: Widgets.AverageScoreOverTime,
    [WidgetNames.SCORE_BREAKDOWN_OVERTIME]: Widgets.ScoreBreakdownOverTime,
    [WidgetNames.TEXT_WIDGET]: Widgets.TextWidget,
    [WidgetNames.METADATA_CONCEPT_BREAKDOWN]: Widgets.MetadataConceptBreakdown,
    [WidgetNames.NPS_BREAKDOWN]: Widgets.NpsBreakdown,
    [WidgetNames.NPS_SCORE]: Widgets.NPSScore,
    [WidgetNames.NPS_SCORE_OVERTIME]: Widgets.NPSOverTime,
    [WidgetNames.LARGEST_DRIVERS_MOVEMENT]: Widgets.LargestDriversMovement,
};

export const Chart = React.forwardRef((props, ref) => {
    const { widgetName, dataProps } = props;
    const WidgetComponent = widgetComponents[widgetName];

    return WidgetComponent ? (
        <WidgetComponent {...dataProps} />
    ) : (
        <>Empty Widget</>
    );
});
